import { SelectDesktop } from '@cian/ui-kit';
import * as React from 'react';

import style from './index.css';
import { EMetroTravelType } from '../../../../../../packages/api-models/common/json_query';
import { clsx } from 'clsx';
import { MaskedInput } from 'shared/components/MaskedInput';
import { plural } from '@cian/utils';

const MIN_TRAVEL_TIME = 1;

const METRO_TRAVEL_TYPE_OPTIONS = [
  { value: EMetroTravelType.Any, label: 'неважно' },
  { value: EMetroTravelType.MapFoot, label: 'пешком' },
  { value: EMetroTravelType.MapTransport, label: 'транспортом' },
];

export interface IMetroHeaderProps {
  minutes?: number;
  onRing?: boolean;
  insideRing?: boolean;
  travelType: EMetroTravelType;
  travelTime: number | undefined;
  fastSelectionButtons?: React.ReactNode;
  onUndergroundTravelChanged(travelType: EMetroTravelType, travelTime: number | undefined): void;
}

export const UndergroundMapModalHeader: React.FC<IMetroHeaderProps> = props => {
  const { onUndergroundTravelChanged, travelTime, travelType } = props;

  const travelTimeFormatted = React.useMemo(() => {
    return travelTime ? travelTime.toString() : undefined;
  }, [travelTime]);

  const minutesText = React.useMemo(() => {
    return travelTime ? plural(travelTime, ['минуты', 'минут', 'минут']) : 'минут';
  }, [travelTime]);

  const handleTravelTypeChange = React.useCallback(
    (value: EMetroTravelType) => {
      onUndergroundTravelChanged(value, travelTime);
    },
    [travelTime, onUndergroundTravelChanged],
  );

  const handleTravelTimeChange = React.useCallback(
    (value: string | undefined) => {
      const valueFormatted = value ? Number(value) : undefined;
      onUndergroundTravelChanged(travelType, valueFormatted);
    },
    [onUndergroundTravelChanged, travelType],
  );

  const handleTravelTimeBlur = React.useCallback(
    (event: React.FocusEvent<HTMLInputElement>) => {
      // При снятии фокуса устанавливаем минимальное значение, если поле пустое
      const value = event.target.value;
      if (value === '') {
        onUndergroundTravelChanged(travelType, MIN_TRAVEL_TIME);
      }
    },
    [onUndergroundTravelChanged, travelType],
  );

  return (
    <div className={style['header']} data-testid="UndergroundPopupHeader">
      <div className={style['label']}>Расстояние до метро:</div>
      <div className={style['travel-type-select-wrapper']} data-testid="TravelType">
        <SelectDesktop value={travelType} onChange={handleTravelTypeChange} options={METRO_TRAVEL_TYPE_OPTIONS} />
      </div>
      {travelType !== EMetroTravelType.Any && (
        <div className={style['minutes-wrapper']}>
          <div className={style['inline-label']}>Не более:</div>
          <div className={clsx(style['inline-block'], style['minutes'])} data-testid="TravelTime">
            <MaskedInput
              inline
              width={60}
              placeholder="10"
              min={MIN_TRAVEL_TIME}
              max={999}
              mask={Number}
              value={travelTimeFormatted}
              onComplete={handleTravelTimeChange}
              onBlur={handleTravelTimeBlur}
            />
          </div>
          <div className={style['inline-label']}>{minutesText}</div>
        </div>
      )}
      <div className={style['buttons']}>{props.fastSelectionButtons}</div>
    </div>
  );
};
